import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WidgetInternalStatus } from '../widget-internal-status';
import { UiWidget } from '@pt/pt-models';

@Component({
  selector: 'pt-widget-layout',
  template: `
    <div class="position-relative">
      <pt-widget-disabled
        *ngIf='internalStatus.isDisabled'
        [showLoader]="internalStatus.viewMode === 'LOADING'">
      </pt-widget-disabled>

      <pt-widget-header
        class='w-100'
        [label]='widget?.label'
        [help]='widget?.help'
        [comment]="comment"
        [unsavedComment]="unsavedComment"
        [showCancelButton]='internalStatus.showCancelButton'
        [showCommentButton]='internalStatus.showCommentButton'
        [showEditButton]='internalStatus.showEditButton'
        [showReloadButton]='internalStatus.showReloadButton'
        [showSaveButton]='internalStatus.showSaveButton'
        [showOptButton]='internalStatus.showOptButton'
        [disabledResetAllButton]="internalStatus.disabledResetAllButton"

        [enableResetAll]="enableResetAll"

        [disabledCancelButton]='internalStatus.disabledCancelButton'
        [disabledCommentButton]='internalStatus.disabledCommentButton'
        [disabledEditButton]='internalStatus.disabledEditButton'
        [disabledOptButton]='internalStatus.disabledOptButton'
        [disabledReloadButton]='internalStatus.disabledReloadButton'
        [disabledSaveButton]='internalStatus.disabledSaveButton'
        [loading]='internalStatus.isLoading'

        (clickResetAll)='clickResetAll.emit(false)'
        (clickSaveWidget)='clickSaveWidget.emit(false)'
        (clickResetWidget)='clickResetWidget.emit()'
        (clickEditWidget)='clickEditWidget.emit()'
        (clickReloadWidget)='clickReloadWidget.emit()'
        (clickCreateOpt)='clickCreateOpt.emit()'
        (clickCommentWidget)='clickCommentWidget.emit()'>
      </pt-widget-header>

      <ng-container *ngIf='!internalStatus.showOptButton'>

        <ng-content>

        </ng-content>

        <pt-widget-error
          *ngIf="internalStatus.viewMode === 'ERROR'"
          [errorMessage]='internalStatus.errorMessage | async'>
        </pt-widget-error>

        <pt-widget-footer>
        </pt-widget-footer>

      </ng-container>
    </div>
  `
})
export class WidgetLayoutComponent {
  @Input() internalStatus: WidgetInternalStatus;
  @Input() widget: UiWidget;
  @Input() enableResetAll = false;
  @Input() comment: string;
  @Input() unsavedComment: string;
  @Output() clickResetAll = new EventEmitter<boolean>();
  @Output() clickEditWidget = new EventEmitter<boolean>();
  @Output() clickSaveWidget = new EventEmitter<boolean>();
  @Output() clickResetWidget = new EventEmitter<boolean>(); // è il cancel
  @Output() clickReloadWidget = new EventEmitter<boolean>();
  @Output() clickCreateOpt = new EventEmitter<boolean>();
  @Output() clickCommentWidget = new EventEmitter<boolean>();
}


